module.exports = __webpack_public_path__ + "img/6001014000.12fd1ea.webp";